<template>
  <section class="orders-page">
    <VDataGridV2
        ref="grid"
        data-url="orders.getOrdersList"
        sticky
        group-children-property="positions"
        @row:dblclick="editPosition"
        @row:click="onRowClick"
        paginated
        selectable
        v-model:selected-rows="selectedPositions"
        checkbox-position="right"
        :disable-group-when="(parent) => parent.id === 1001282 || parent.id === 1000215"
    >
      <!-- Колонки для позиций -->

      <VDataGridGroupV2>
        <template #default="{ parent, children, isDisabled, isSelected }">
          {{parent.id}}
          children: {{children.length}}
          isDisabled: {{isDisabled}}
          isSelected: {{isSelected}}
        </template>
      </VDataGridGroupV2>


      <VDataGridColumnV2
        label="id"
      >
        <template #default="{ row }">
          {{row.id}}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        label="кол-во"
      >
        <template #default="{ row, isSelected, isDisabled }">
          {{row.qty}}
          isSelected: {{isSelected}}
          isDisabled: {{isDisabled}}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        label="цена"
      >
        <template #label>
          Цена поставщика
          <div class="description">Цена покупателя</div>
        </template>
        <template #default="{ row }">
          {{row.priceSeller}}
          <div class="description">
          {{row.priceFullBuyer}}
          </div>
        </template>
      </VDataGridColumnV2>

      <!-- В колонке с кнопкой -->
      <VDataGridColumnV2 id="action">
        <template #default="{ row }">
          <ExampleUsageContextMenu
              use-button

              :row="row"
              @edit="editPosition"
              @copy="copyPosition"
              @delete="deletePosition"
          />
        </template>
      </VDataGridColumnV2>

      <!-- По правому клику -->
      <VDataGridContextMenuV2>
        <template #default="{ row }">
          <ExampleUsageContextMenu
              :row="row"
              @edit="editPosition"
              @copy="copyPosition"
              @delete="deletePosition"
          />
        </template>
      </VDataGridContextMenuV2>

      Панель действий
      <VDataGridActionBarV2>
        <template #default="{ selectedRows }">
          <span>Выбрано {{ selectedRows.length }} позиций</span>
          <VButton theme="link" @click="clearSelection">Отмена</VButton>
        </template>
      </VDataGridActionBarV2>
    </VDataGridV2>
  </section>
</template>

<script lang="ts">
import Partner from "@/domains/Partners/Partner";
import PartnersService from "@/domains/Partners/PartnersService";
import ExampleUsageContextMenu from "@/lib/components/VDataGridV2/examples/ExampleUsageContextMenu.vue";

export default defineComponent({
  name: 'PartnersPageExample',

  data() {
    return {
      Partner,
      selectedPositions: [] as Record<string, unknown>[],
    };
  },

  components: { ExampleUsageContextMenu },

  computed: {
    partnerPatternProps() {
      return {
        placeholder: 'Введите название',
        clearable: true,
        options: PartnersService.partnerTypeList
      }
    },
    typesProps() {
      return {
        options: PartnersService.partnerTypeList,
        multiple: true,
        clearable: true,
      }
    },
  },

  methods: {
    editPosition(row: Record<string, unknown>): void {
      // this.$core.dialogs.show('order-position-edit', { position: row });
    },

    copyPosition(row: Record<string, unknown>): void {
      // ...
    },

    deletePosition(row: Record<string, unknown>): void {
      // ...
    },

    createShipment(): void {
      // ...
    },

    createAssembly(): void {
      // ...
    },

    onRowClick(row): void {
      // console.log(row)
    },

    clearSelection(): void {
      this.selectedPositions = [];
    },

    formatNumber(val: unknown): string {
      return this.$core.utils.number.numberFormat(val);
    },

    formatDate(val: unknown): string {
      return this.$core.utils.date.format(val);
    },
  },
});
</script>
